import { render, staticRenderFns } from "./DPDForm.vue?vue&type=template&id=875d6d90&scoped=true"
import script from "./DPDForm.vue?vue&type=script&lang=js"
export * from "./DPDForm.vue?vue&type=script&lang=js"
import style0 from "./DPDForm.vue?vue&type=style&index=0&id=875d6d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875d6d90",
  null
  
)

export default component.exports